const BGMReducers = (
  state = {
    enabled: true,
    song: "back2_", //預設音樂
    musicVolume: 0.2, // 預設音量 20%
  },
  action
) => {
  switch (action.type) {
    case "toggleBGM":
      return action.payload;
    default:
      return state;
  }
};

export default BGMReducers;
